import FormError from './FormError'

export default class FormValidable {
  constructor (options) {
    this.validators = []
    options.validators?.forEach(this.addValidator.bind(this))
    this.valid = !this.validators.length
    this.invalid = !this.valid
    this.errors = []
  }

  async validate () {
    let valid = true
    let errors = []

    const syncValidators = this.validators.filter((validator) => !validator.async)
    const asyncValidators = this.validators.filter((validator) => validator.async)

    syncValidators.forEach((validator) => {
      let result = validator.validate(this.value)
      valid = valid && result
      if (!result) errors.push(new FormError({ validable: this, name: validator.name, message: validator.error }))
    })

    await Promise.all(asyncValidators.map(async (validator) => {
      let result = await validator.validate(this.value)
      valid = valid && result
      if (!result) errors.push(new FormError({ validable: this, name: validator.name, message: validator.error }))
    }))

    this.valid = valid
    this.invalid = !valid
    this.errors = errors

    if (this.validateFromChildren && valid) this.validateFromChildren()
    if (this.template) await this.template.validate()
    if (this.form) await this.form.validate()
    if (this.onChange) this.onChange(this)
    if (this.update) this.update()
  }

  async addValidator (validator) {
    const validatorAlreadyPresent = this.validators.some((presentValidator) => presentValidator.name === validator.name)
    if (validatorAlreadyPresent) {
      console.error(`Cannot add duplicate validator ${validator.name} to validable ${this.name}`)
    } else {
      this.validators.push(validator)
      await this.validate()
    }
  }

  async removeValidator (validatorName) {
    this.validators = this.validators.filter((validator) => validator.name !== validatorName)
    await this.validate()
  }
}
